// @flow
import { connect } from 'react-redux';
import SelectSubscriptionToActivatePage from './SelectSubscriptionToActivatePage';
import { visibleSubscriptionsToActivateSelector } from '../../../modules/Subscriptions';
import { confirmSubscriptionSelectionDuringActivate } from '../../../modules/SignUp';
import { hasVisibleSubscriptionsSelector } from '../../../modules/Dashboard';
import { isLoadingSelector } from '../../../modules/LoadingStatus';
import { setSubscriptionToUpdate } from '../../../modules/Subscriptions';

import type { DispatchProps, StateProps } from './SelectSubscriptionToActivatePage';

const mapStateToProps = (state): StateProps => ({
  subscriptions: visibleSubscriptionsToActivateSelector(state),
  hasSubscriptionsToSwap: hasVisibleSubscriptionsSelector(state),
  isLoading: isLoadingSelector(state, 'confirmSubscriptionSelectionDuringActivate'),
});

const mapDispatchToProps: DispatchProps = {
  onConfirm: confirmSubscriptionSelectionDuringActivate,
  setSubscriptionToUpdate,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSubscriptionToActivatePage);
